import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { RequireReduxData } from '~/components/RequireReduxData';
import { DispatchReduxFetch } from '~/hooks/initializeData';
import { LoadingView } from '~/scenes/PortalViews/components/LoadingView';

type PropsType = {
  required: DispatchReduxFetch[];
  children?: ReactNode;
};

export const EmbeddedViewDataInitialization = (props: PropsType) => {
  const { required, children } = props;

  const { t } = useTranslation();

  return (
    <RequireReduxData
      required={required}
      renderLoading={(percentage) => (
        <LoadingView>
          {t('loadingPortalView')} - {percentage}
        </LoadingView>
      )}
    >
      {children}
    </RequireReduxData>
  );
};
